import { render } from "./DFooter.vue?vue&type=template&id=73a60aed&scoped=true"
import script from "./DFooter.vue?vue&type=script&lang=js"
export * from "./DFooter.vue?vue&type=script&lang=js"

import "./DFooter.vue?vue&type=style&index=0&id=73a60aed&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73a60aed"

export default script